import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseReadOnlyService } from '../../services/base-readonly.service';
import { PublicHealthRecordType } from './public-health-record-type.model';

@Injectable({
    providedIn: 'root'
})
export class PublicHealthRecordTypeService extends BaseReadOnlyService<PublicHealthRecordType> {

    constructor(protected http: HttpClient) {
        super(http, 'publichealthrecordtype');
    }
}
